import { makeStringToDecimalString } from '@/utils/util';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ForecastSummaryCardProps {
  testId?: string;
  className?: string;
  title: string;
  data?: ForecastSummaryCardData;
}

export const ForecastSummaryCard: React.FC<ForecastSummaryCardProps> = ({
  testId,
  className,
  title,
  data,
}) => {
  const { t } = useTranslation();

  return (
    <div
      data-testid={testId}
      className={`w-[540px] rounded-[10px] bg-light-1 p-5 pt-[13px] shadow-3 ${className}`}
    >
      <p className="cjk-13-medium leading-[23px] tracking-[-0.5px]">{title}</p>
      <div className="mt-[10px] grid grid-cols-4">
        <div>
          <p className="noto-13-light leading-[19px] tracking-[-0.065px] text-dark-10">
            {t('forecast.percentageError', { context: 'short' })}
          </p>
          <p
            className={`${data?.errAvg ? 'pop-17-semibold text-dark-2' : 'pop-13-semibold text-dark-10'} mt-[6px] leading-none tracking-[-0.17px]`}
          >
            {data?.errAvg
              ? `${makeStringToDecimalString(data.errAvg, 2)} ${t('forecast.percentageError', { context: 'unit' })}`
              : '제출실적없음'}
          </p>
        </div>
        <div>
          <p className="noto-13-light leading-[19px] tracking-[-0.065px] text-dark-10">
            {t('forecast.settlementAmount', { context: 'short' })}
          </p>
          <p
            className={`${data?.income ? 'pop-17-semibold text-dark-2' : 'pop-13-semibold text-dark-10'} mt-[6px] leading-none tracking-[-0.17px]`}
          >
            {data?.income
              ? `${makeStringToDecimalString(data.income, 0, true)} ${t('forecast.settlementAmount_unit', { context: '1' })}`
              : '제출실적없음'}
          </p>
        </div>
        <div>
          <p className="noto-13-light leading-[19px] tracking-[-0.065px] text-dark-10">
            {t('overview.utilization', { context: 'average' })}
          </p>
          <p
            className={`${data?.availTransMeterAvg ? 'pop-17-semibold text-dark-2' : 'pop-13-semibold text-dark-10'} mt-[6px] leading-none tracking-[-0.17px]`}
          >
            {data?.availTransMeterAvg
              ? `${makeStringToDecimalString(data.availTransMeterAvg, 2)} ${t('forecast.percentageError', { context: 'unit' })}`
              : '제출실적없음'}
          </p>
        </div>
        <div>
          <p className="noto-13-light leading-[19px] tracking-[-0.065px] text-dark-10">
            {t('forecast.generation', { context: 'short' })}
          </p>
          <p
            className={`${data?.powerMetered ? 'pop-17-semibold text-dark-2' : 'pop-13-semibold text-dark-10'} mt-[6px] leading-none tracking-[-0.17px]`}
          >
            {data?.powerMetered
              ? `${makeStringToDecimalString(data.powerMetered, 2, true)} ${t('forecast.generationPerformance_unit', { context: '1' })}`
              : '제출실적없음'}
          </p>
        </div>
      </div>
    </div>
  );
};
